import MessageController from './message-controller'
import { afterXhrRequest } from '../../shared/helpers'

class ReplyController extends MessageController {
  connect() {
    super.connect()
    this.messageContainer = this.element.parentElement
    this.formClass = 'reply-form-content'
  }

  //
  // INTERNAL USE
  //

  removeDeletedMessage(response) {
    afterXhrRequest(response)
    const messageDiv = this.messageTarget.closest('.messages--message-div')
    messageDiv.innerHTML = response.data.html
  }

  reloadIfMatchingID() {
  }
}

export default ReplyController



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/reply-controller.js